import {brandsBase} from '@root/brands/brandsBase';
import type {BrandBase} from '@root/brands/BrandBase';

export type BrandId = keyof typeof brandsBase & string;

export const getBrandBase = (brandId: BrandId): BrandBase => {
  const brand = brandsBase[brandId];

  if (!brand) {
    throw new Error(`Unknown brand "${brandId}" requested`);
  }

  return brand;
};
